import styles from './Icon.style';

function LogoIcon(props) {
  const { classes } = props;

  let className = classnames(classes.root, props.className);

  return (
    <svg
      className={className}
      height="58px"
      version="1.1"
      viewBox="0 0 58 58"
      width="58px"
    >
      <defs>
        <linearGradient
          id="logo-icon-linearGradient-3"
          x1="49.1781069%"
          x2="0%"
          y1="99.1781069%"
          y2="50%"
        >
          <stop offset="0%" stopColor="#8E9DFF" stopOpacity="0.362318841" />
          <stop offset="100%" stopColor="#B97BD3" stopOpacity="0.71" />
        </linearGradient>
        <linearGradient
          id="llogo-icon-inearGradient-4"
          x1="50%"
          x2="100%"
          y1="0%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#9BA6EE" />
          <stop offset="100%" stopColor="#9F75B1" />
        </linearGradient>
        <linearGradient
          id="logo-icon-linearGradient-5"
          x1="50%"
          x2="1.31751264%"
          y1="100%"
          y2="2.63502529%"
        >
          <stop offset="0%" stopColor="#8E9DFF" />
          <stop offset="100%" stopColor="#D68FF3" />
        </linearGradient>
      </defs>
      <g
        fill="none"
        fillRule="evenodd"
        id="Page-1"
        stroke="none"
        strokeWidth="1"
      >
        <g id="Active-Copy-7" transform="translate(-18.000000, -17.000000)">
          <g id="Sidebar" transform="translate(0.000000, -10.000000)">
            <g id="Icon-Copy-2" transform="translate(32.000000, 39.000000)">
              <path
                d="M10.3125,30 L5.4,30 C2.41766235,30 2.14158786e-15,27.5823376 1.77635684e-15,24.6 L0,5.4 C-3.65231026e-16,2.41766235 2.41766235,2.32420338e-15 5.4,1.77635684e-15 L10.3125,0 L12.890625,0 L24.6,0 C27.5823376,2.32420338e-15 30,2.41766235 30,5.4 L30,15 L30,24.6 C30,27.5823376 27.5823376,30 24.6,30 L10.3125,30 Z"
                fill="black"
                fillOpacity="1"
                filter="url(#filter-2)"
                id="path-0"
              />
              <path
                d="M10.3125,30 L5.4,30 C2.41766235,30 2.14158786e-15,27.5823376 1.77635684e-15,24.6 L0,5.4 C-3.65231026e-16,2.41766235 2.41766235,2.32420338e-15 5.4,1.77635684e-15 L10.3125,0 L12.890625,0 L24.6,0 C27.5823376,2.32420338e-15 30,2.41766235 30,5.4 L30,15 L30,24.6 C30,27.5823376 27.5823376,30 24.6,30 L10.3125,30 Z"
                fill="#32383F"
                fillOpacity="0.400000006"
                fillRule="evenodd"
                id="path-1"
              />
              <path
                d="M18.290625,0 L30,0 L30,30 L18.290625,30 C15.3082874,30 12.890625,27.5823376 12.890625,24.6 L12.890625,5.4 C12.890625,2.41766235 15.3082874,2.32420338e-15 18.290625,1.77635684e-15 Z"
                fill="url(#logo-icon-linearGradient-3)"
                id="Rectangle-Copy-3"
                opacity="0.400000006"
                transform="translate(21.445312, 15.000000) scale(-1, 1) translate(-21.445312, -15.000000) "
              />
              <path
                d="M10.3125,0 L24.6,0 C27.5823376,-5.47846538e-16 30,2.41766235 30,5.4 L30,15 L10.3125,15 L10.3125,0 Z"
                fill="url(#logo-icon-linearGradient-4)"
                id="Rectangle-Copy"
                opacity="0.5"
              />
              <path
                d="M5.4,0 L15,0 L15,30 L5.4,30 C2.41766235,30 2.14158786e-15,27.5823376 1.77635684e-15,24.6 L0,5.4 C-3.65231026e-16,2.41766235 2.41766235,2.32420338e-15 5.4,1.77635684e-15 Z"
                fill="url(#logo-icon-linearGradient-5)"
                id="Rectangle"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

LogoIcon.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
};

export default withStyles(styles)(LogoIcon);
